import React from "react";

function FoundationAssessment() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Foundation Assessment</h1>
      <p style={{ color: "gray" }}>Content for Foundation Assessment will be added soon.</p>
    </div>
  );
}

export default FoundationAssessment;
